import { ToggleGroup, ToggleGroupItem } from '@playbooks/ui/components/toggle-group'
import { Check } from 'lucide-react'
import { InputProps } from '../types'
import { cn } from '@playbooks/ui/lib/utils'
import { useTranslation } from '../../../contexts/localization/Localization'

export function Checkbox({ question, onChange }: InputProps) {
  const { text } = useTranslation()

  const yesText = text('yes')
  const noText = text('no')

  return (
    <ToggleGroup
      onValueChange={() => {
        onChange(!question.value)
      }}
      variant="outline"
      type="single"
      className="w-max!"
      value={!!question.value ? 'yes' : 'no'}
    >
      <ToggleItem value="yes">{yesText}</ToggleItem>
      <ToggleItem value="no">{noText}</ToggleItem>
    </ToggleGroup>
  )
}

const ToggleItem = ({ children, value }: { value: string; children: React.ReactNode }) => {
  return (
    <ToggleGroupItem value={value as string} className="px-4 group">
      <div className="flex items-center px-2 gap-2">
        <div
          className={cn(
            'size-4 border-foreground border rounded-full bg-transparent text-background flex items-center justify-center text-xs',

            'group-data-[state=on]:bg-foreground',

            'group-data-[view=funnel]/app:group-data-[state=on]:bg-(--color-ac-accent)',
            'group-data-[view=funnel]/app:group-data-[state=on]:border-(--color-ac-accent)',
            'group-data-[view=funnel]/app:group-data-[state=on]:text-white',
          )}
        >
          <Check className="size-3 group-data-[state=on]:opacity-100 opacity-0" />
        </div>
        <div>{children}</div>
      </div>
    </ToggleGroupItem>
  )
}
